import { createFileRoute, redirect } from '@tanstack/react-router'
import {
  GlobalSearchParams,
  SEARCH_PARAM_ORG_ID,
} from 'routes/(global_search_params)/-searchParams'
import { createValueStorySearch } from 'routes/value-stories/-searchParams'
import { Route as NewRoute } from 'routes/value-stories/edit'

export const Route = createFileRoute(
  '/value-stories/(deprecated_routes)/$siteID/$valueStoryID/edit'
)({
  beforeLoad: ({ params }) => {
    const { siteID, valueStoryID } = params

    throw redirect({
      to: NewRoute.to,
      search: (prev: Record<string, unknown> & GlobalSearchParams) => ({
        ...prev,
        ...createValueStorySearch({
          orgId: prev[SEARCH_PARAM_ORG_ID],
          siteId: siteID,
          valueStoryId: valueStoryID,
        }),
      }),
      replace: true,
    })
  },
})
